import React from 'react';  
import DOMPurify from 'dompurify';  
  
interface HtmlContentProps {
    htmlString :string 
}

const HtmlContent: React.FC<HtmlContentProps> = ({htmlString}) =>
{
const sanitizedHtmlString = DOMPurify.sanitize(htmlString);  
  return (  
    <div dangerouslySetInnerHTML={{ __html: sanitizedHtmlString }} />  
  );  
}
  
export default HtmlContent;  
